// extracted by mini-css-extract-plugin
export default {"root":"_3JQK5","buttonWrapper":"_2-JBK","text":"_29cEx"};